import { css } from "@emotion/react";

export const addStyles = direction => props => css`
  border: none;
  width: 48px;
  height: 48px;
  padding: 0;

  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    width: 60px;
    height: 60px;
  }

  svg {
    transform: ${direction === "right" ? "none" : "rotate(180deg)"};
    stroke: ${props.theme.colors.white};
  }

  &:disabled {
    background-color: transparent;
    border: 1px solid ${props.theme.colors.secondary.minor};

    svg {
      stroke: ${props.theme.colors.secondary.minor};
    }
    &:hover {
      background-color: transparent;
    }
  }

  &:hover {
    background-color: ${props.theme.colors.black};
  }

  &:active {
    background-color: ${props.theme.colors.black};
  }
`;
